import { render, staticRenderFns } from "./ResultFocus.vue?vue&type=template&id=12f2e82a&lang=html"
import script from "./ResultFocus.vue?vue&type=script&lang=js"
export * from "./ResultFocus.vue?vue&type=script&lang=js"
import style0 from "./ResultFocus.vue?vue&type=style&index=0&id=12f2e82a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports